var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showSubscriptionBanner ? _c('div', {
    staticClass: "sticky top-0 z-20"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_c('div', {
    staticClass: "bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600 absolute text-center py-5 -mt-8 w-6/12 left-3/12 right-3/12 text-base flex items-center justify-center"
  }, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Votre abonnement a été validé")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "Group189"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-16 mb-8"
  }, [_c('div', {
    staticClass: "-my-2 py-2"
  }, [_vm.tab_display == 'informations' ? _c('MessageHeader', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }) : _vm._e(), _vm._v(" "), _vm.isInformationsPage ? _c('div', {
    staticClass: "sticky z-10 top-48 md:top-0 bg-black"
  }, [_vm.saving ? _c('div', {
    staticClass: "absolute flex items-center justify-center cursor-pointer bg-pink-600 shadow-pink hover:shadow-outline-pink text-white z-0 w-14 h-14 rounded-full md:right-15 md:mt-10 ml-5/12 md:ml-0 top-96 md:top-0"
  }, [_c('span', {
    staticClass: "h-6 w-6 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "absolute flex items-center justify-center cursor-pointer bg-pink-600 shadow-pink hover:shadow-outline-pink text-white z-0 w-14 h-14 rounded-full md:right-15 md:mt-10 ml-5/12 md:ml-0 top-96 md:top-0",
    on: {
      "click": _vm.save_infos
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6",
    attrs: {
      "name": "save"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('h3', {
    staticClass: "mt-5 mb-5 lg:my-15 2xl:my-20 w-full"
  }, [_vm._v("\n          Paramètres du compte\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('nav', {
    staticClass: "flex justify-between md:justify-center md:space-x-10 text-gray-600 cursor-pointer text-center overflow-x-auto w-2/3 md:w-full"
  }, [_c('router-link', {
    staticClass: "flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light",
    class: {
      'text-indigo-600 font-normal': _vm.tab_display == 'informations'
    },
    attrs: {
      "to": {
        name: 'Accountinformations'
      }
    }
  }, [_vm._v("\n              Mes informations\n            ")]), _vm._v(" "), _vm.isAdminPay || _vm.$trial() ? _c('router-link', {
    staticClass: "flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light pl-4 md:pl-0",
    class: {
      'text-indigo-600 font-normal': _vm.tab_display == 'abonnements'
    },
    attrs: {
      "to": {
        name: 'Accountsubscription'
      }
    }
  }, [_vm._v("\n              Mon abonnement\n            ")]) : _vm._e(), _vm._v(" "), _vm.isAdminPay ? _c('router-link', {
    staticClass: "flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light pl-4 md:pl-0",
    class: {
      'text-indigo-600 font-normal': _vm.tab_display == 'paiements'
    },
    attrs: {
      "to": {
        name: 'Accountbillinghistory'
      }
    }
  }, [_vm._v("\n              Mes historiques de paiement\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('icon', {
    staticClass: "ml-3 text-indigo-600 md:hidden block",
    attrs: {
      "name": "arrow-right_1"
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12 w-full"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Paramètres du compte\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._v("\n        Gérez vos informations générales, votre abonnement et retrouvez l’historique de vos paiements depuis cet espace.\n      ")])]);

}]

export { render, staticRenderFns }